const address1 = document.querySelector('#address1');
const address2 = document.querySelector('#address2');
const address1coords = [52.0676723, 4.3490487];
const address2coords = [52.41437, 16.96430];
const dY = 0.00150;
const dX = 0.00150;
const zoomLevel = 17;
let mapCenter1 = address1coords;
let mapCenter2 = address2coords;


const setMapCenterCoords = () => {
    if(window.innerWidth < 768){
        mapCenter1 = [address1coords[0] - dY, address1coords[1]];
        mapCenter2 = [address2coords[0] - dY, address2coords[1]];
    } else if(window.innerWidth >= 768 && window.innerWidth < 1440){
        mapCenter1 = [address1coords[0], address1coords[1] + dX];
        mapCenter2 = [address2coords[0], address2coords[1] + dX];
    } else {
        mapCenter1 = address1coords;
        mapCenter2 = address2coords;
    }
    return mapCenter1
}

var map = new L.Map("map", {
        center: setMapCenterCoords(),
        zoom: zoomLevel,
        attribution: 'Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a>',
    });
const markerIcon = L.icon({
    iconUrl: '../assets/img/marker.png',
    iconAnchor: [19.5, 52]
});
L.tileLayer('https://b.tile.openstreetmap.org/{z}/{x}/{y}.png').addTo(map)
L.marker(address1coords, {icon: markerIcon}).addTo(map);
L.marker(address2coords, {icon: markerIcon}).addTo(map);

const handleAddress = (coords) => {
    map.flyTo(coords, zoomLevel)
}

const setCenter = () => {
    setMapCenterCoords();
    handleAddress(mapCenter1);
}

address1.addEventListener('click', () => handleAddress(mapCenter1));
address2.addEventListener('click', () => handleAddress(mapCenter2));
window.addEventListener('resize', setCenter);

const form = document.querySelectorAll('.form__field');

const labelControl = (remove, name) => {
    const label = document.querySelector(`.form__label[for="${name}"]`);
    if(remove) {
        label.classList.remove('form__label--active')
    } else {
        label.classList.add('form__label--active')
    }
}

const handleInputFocusOut = (event) => {
    if(event.target.value === "") {
        labelControl(true, event.target.name)
    }
    event.target.removeEventListener('focusout', handleInputFocusOut);
}

const handleInputFocusIn = (event) => {
    labelControl(false, event.target.name)
    event.target.addEventListener('focusout', handleInputFocusOut)
}

form.forEach(e => {
    e.childNodes.forEach(child => {
        if(child.name){
            child.addEventListener('focusin', handleInputFocusIn)
            if(child.value !== ""){
                labelControl(false, child.name)
            }
        }
    })
})
